import Privileges from './privileges-layout';

export default Privileges;
